import React from 'react';
import cn from 'classnames';
import upperFirst from 'lodash/upperFirst';
import { Link } from '@landing/ui';
import * as styles from './Button.module.scss';

export default function Button({
  size = 'md',
  theme = '',
  textColor = '',
  fullWidth,
  fullWidthMobile,
  disabled,
  children,
  className,
  tag = 'button',
  ...other
}) {
  const Wrapper = tag === 'a' ? Link : tag;

  return (
    <Wrapper
      className={cn(
        styles.button,
        size && styles[`size${size.toUpperCase()}`],
        theme && styles[`theme${upperFirst(theme)}`],
        textColor && styles[`textColor${upperFirst(textColor)}`],
        fullWidth && styles.fullWidth,
        fullWidthMobile && styles.fullWidthMobile,
        disabled && styles.disabled,
        className,
      )}
      disabled={disabled}
      {...other}
    >
      {children}
    </Wrapper>
  );
}
